import React from 'react';

import { Form } from 'react-final-form';

import { TestCyclesOverviewFormView } from './TestCyclesOverviewForm.view';

export interface TestCyclesOverviewFormProps {
  initialValues: unknown;
}

export const TestCyclesOverviewForm: React.FC<TestCyclesOverviewFormProps> = ({
  initialValues,
}: TestCyclesOverviewFormProps) => {
  return (
    <Form initialValues={initialValues} onSubmit={() => null}>
      {() => <TestCyclesOverviewFormView />}
    </Form>
  );
};
